import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';

import { WidgetItem, WidgetReportItem } from './widget-item';
import { WidgetPost, WidgetReportPost } from './widget-post';

@Injectable()
export class WidgetHostService {

    constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

    loadComponent(viewContainerRef: ViewContainerRef, postItem: WidgetItem) {
        const componentFactory = this.componentFactoryResolver
            .resolveComponentFactory(postItem.component);
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);

        const myPost: WidgetPost = <WidgetPost>componentRef.instance;

        // myPost.stateOptions = postItem.stateOptions;
        myPost.data = postItem.data;
    }

    loadReportComponent(viewContainerRef: ViewContainerRef, postItem: WidgetReportItem) {
        const componentFactory = this.componentFactoryResolver
            .resolveComponentFactory(postItem.component);
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        const myPost: WidgetReportPost = <WidgetReportPost>componentRef.instance;
        myPost.data = postItem.data;
    }



}



// WEBPACK FOOTER //
// ./src/app/shared/widget/widget-host-service.ts